import { Box, Typography, Card, CardContent, useTheme } from "@mui/material";
import { iconsMap } from "../utils/iconsMap";
import useResponsiveSpacingGrid from "../../hooks/useResponsiveSpacingGrid";
import { formatTextWithHighlight } from "../utils/formatTextWithHighlight";

interface SectionCardProps {
  heading: string;
  body: string;
  icon?: string;
  iconColor?: string;
  iconBg?: string;
  highlightColor?: string;
}

const SectionCard: React.FC<SectionCardProps> = ({
  heading,
  body,
  icon,
  iconColor,
  iconBg = "transparent",
  highlightColor,
}) => {
  const IconComponent = icon ? iconsMap[icon] : null;
  const spacing = useResponsiveSpacingGrid();
  const padding = useResponsiveSpacingGrid(1, 2, 2);
  const theme = useTheme();
  const iconColorYellow = theme.palette.primary.main;
  const hightlightColorYellow = theme.palette.primary.light;

  return (
    <Card
      sx={{
        mb: spacing,
        backgroundColor: theme.palette.background.paper,
        color: "white",
        borderRadius: 2,
        border: `1px solid ${theme.palette.text.disabled}`,
      }}
    >
      <CardContent sx={{ p: padding }}>
        <Box display="flex" alignItems="center" mb={1} gap={2}>
          {IconComponent && (
            <Box
              sx={{
                backgroundColor: iconBg,
                padding: 1,
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <IconComponent
                style={{
                  color: iconColor ? iconColor : iconColorYellow,
                  fontSize: 28,
                }}
              />
            </Box>
          )}
          <Typography variant="h5" fontWeight={700}>
            {heading}
          </Typography>
        </Box>
        <Typography
          variant="body1"
          color="inherit"
          sx={{ textAlign: "justify" }}
        >
          {formatTextWithHighlight(
            body,
            highlightColor ? highlightColor : hightlightColorYellow
          )}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default SectionCard;
